export default __webpack_public_path__ + "static/media/employeePage.8c75798c.png";